import { config } from '@iheartjane/config';
import qs from 'qs';

import { request } from '@jane/monolith/utils/request';
import type { Address } from '@jane/shared/types';

const buildUrl = (url = '') => `${config.apiPath}/pos_cart${url}`;

export const PosCartSource = {
  get(deliveryAddress: Address | null | undefined, cart_uuid: string) {
    const address = deliveryAddress || {};
    return request(buildUrl(), { method: 'GET' }, { ...address, cart_uuid });
  },
};

export const getPosCartSource = (
  cartUuid: string,
  deliveryAddress: Address | null | undefined
) => {
  const queryParams = qs.stringify({
    ...deliveryAddress,
    cart_uuid: cartUuid,
  });
  return {
    url: buildUrl(`?${queryParams}`),
  };
};
